import moment from 'moment';
import { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import useIndexDBValue from 'src/app/hook/useIndexDBValue';
import { seachUserMetadata } from 'src/app/modules/auth/core/_requests';
import { SelectEditor, useSelectEditorManager } from 'src/app/modules/component/select-editor';
import { TimeEditor } from 'src/app/modules/component/time-editor/TimeEditor';
import { useTimeEditorManager } from 'src/app/modules/component/time-editor/useTimeEditorManager';
import { updateOrderGroupFields } from 'src/app/modules/phan-he-kham-benh/services/ChiDinhDVService';
import { IDanhSachDanhMuc } from 'src/app/modules/phan-he-tiep-nhan-thanh-toan/models/TiepDonModel';
import { hasAuthority, KEY_AUTHORITIES } from 'src/app/modules/utils/Permission';
import ButtonInPhieu from '../../../../component/button-in-phieu';
import { ConfirmDialog } from '../../../../component/ConfirmDialog';
import DanhSachPhieu from '../../../../component/DanhSachPhieu';
import InputSearch from '../../../../component/InputSearch';
import LabelRequired from '../../../../component/LabelRequired';
import { TableCustom } from '../../../../component/table/table-custom/TableCustom';
import { mauColumn } from '../../../../phan-he-kham-benh/constants/Columns';
import { WORKFLOW_MEDICAL_ITEM_STATUS_CODE } from '../../../../phan-he-kham-benh/constants/Thuoc';
import { IInPhieuChiDinhThuocParams } from '../../../../phan-he-kham-benh/models/ThuocModels';
import { deleteDonThuoc, huyGuiDonThuoc, printPhieuChiDinhThuoc } from '../../../../phan-he-kham-benh/services/ThuocService';
import ChiDinhMau from '../../../../phan-he-noi-tru-dieu-tri/components/chi-dinh-mau';
import { getThongTinPhieuThuoc, updateKeThuoc } from '../../../../phan-he-noi-tru-dieu-tri/services/DieuTriServices';
import { APP_DATE_TIME_FORMAT, CODE, KEY, KEY_DS_DANH_MUC_TIEP_DON, ORDER_TYPE_ID, REQUEST_FROM, REQUEST_TYPE, RESPONSE_MESSAGE } from '../../../../utils/Constant';
import { formatDateTime, getErrorMessage } from '../../../../utils/FormatUtils';
import WfButton from '../../../../workflows/components/WfButton';
import { WfConstTrackerClinical } from '../../../../workflows/Constant';
import { usePhanHeNoiTruContext } from '../../../PhanHeNoiTruContext';
import { getDsPhieuThuocVatTu } from '../../../services/HanhChinhServices';

type Props = {
    treatmentSheetId?: string
    allowOrder?: boolean
}

const Mau = ({ treatmentSheetId, allowOrder = true }: Props) => {

    const { benhNhanHanhChinh, statusChangedEvent } = usePhanHeNoiTruContext();
    const [dsPhieu, setDsPhieu] = useState<any[]>([]);
    const [selectedPhieu, setSelectedPhieu] = useState<any>(null);
    const [donMauInfo, setDonMauInfo] = useState<any>(null);

    const allowEdit = !benhNhanHanhChinh?.concluded && hasAuthority(KEY_AUTHORITIES.UPDATE_FIELDS.PHIEU_CHI_DINH);

  const { value: danhSachDanhMuc } = useIndexDBValue<IDanhSachDanhMuc>({
    key: KEY_DS_DANH_MUC_TIEP_DON,
  });

    const onUpdate = (updatedData: any, field: string) => {
      if (!updatedData?.[field]) return;
      // Cập nhật selectedPhieu với data mới
      setDonMauInfo((prev: any) => ({
        ...prev,
        [field]: updatedData[field]
      }));

      // Cập nhật trong danh sách phiếu
      setDsPhieu((prevList: any[]) =>
        prevList.map((phieu: any) =>
          phieu.id === donMauInfo?.id
            ? { ...phieu, [field]: updatedData[field] }
            : phieu
        )
      );
    }

    const doctorOrderDayManager = useTimeEditorManager({
      name: "doctorOrderDay",
      idFieldName: "orderGroupId",
      values: donMauInfo,
      updateFields: updateOrderGroupFields,
      onUpdateSuccess: (updatedData) => onUpdate(updatedData, "doctorOrderDay"),
    });

    const designatedDateManager = useTimeEditorManager({
      name: "designatedDate",
      idFieldName: "orderGroupId",
      values: donMauInfo,
      updateFields: updateOrderGroupFields,
      onUpdateSuccess: (updatedData) => onUpdate(updatedData, "designatedDate"),
    });

  const indicationPersonSelectManager = useSelectEditorManager({
    name: "designatedPerson",
    idFieldName: "orderGroupId",
    values: donMauInfo,
    updateFields: updateOrderGroupFields,
    buildPayload: (option) => ({
      designatedPerson: option?.fullName,
      indicationTime: donMauInfo?.designatedDate
    }),
    onUpdateSuccess: (updatedData) => onUpdate(updatedData, "designatedPerson"),
    enableConfirmWithReason: false, // Không dùng confirm with reason cho trường hình thức
  });

  const designatedPlaceSelectManager = useSelectEditorManager({
    name: "designatedPlace",
    idFieldName: "orderGroupId",
    values: donMauInfo,
    updateFields: updateOrderGroupFields,
    buildPayload: (option) => ({
      requestDeptCode: option?.code,
      requestDeptName: option?.name,
      designatedPlace: option?.name,
      indicationTime: donMauInfo?.designatedDate
    }),
    onUpdateSuccess: (updatedData) => onUpdate(updatedData, "designatedPlace"),
    enableConfirmWithReason: false, // Không dùng confirm with reason cho trường hình thức
  });

    const handleGetDsPhieu = async () => {
        try {
            let { data } = await getDsPhieuThuocVatTu(benhNhanHanhChinh?.treatmentId, ORDER_TYPE_ID.MAU, treatmentSheetId);
            if (CODE.SUCCESS === data?.code) {
                let dsPhieuConverted = data?.data?.map((item: any) => {
                    return {
                        ...item,
                        date: moment(item?.doctorOrderDay).format("DD/MM/YYYY"),
                    };
                });
                setDsPhieu(dsPhieuConverted || []);
                setSelectedPhieu(null);
            } else {
                setDsPhieu([]);
            }
        } catch (error) {
            console.error(error);
        }
    }

    const handleSelectPhieu = async (id: any) => {
        try {
            let { data } = await getThongTinPhieuThuoc({ medicalItemGroupId: id });
            if (CODE.SUCCESS === data?.code) {
                setDonMauInfo(data?.data);
            } else {
                setDsPhieu([]);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (selectedPhieu?.id) {
            handleSelectPhieu(selectedPhieu?.id);
        } else {
            setDonMauInfo(null);
        }
    }, [selectedPhieu]);

    useEffect(() => {
        benhNhanHanhChinh?.treatmentId && handleGetDsPhieu();
    }, [benhNhanHanhChinh?.treatmentId, statusChangedEvent, treatmentSheetId]);

  return (
    <Row className="h-100 spaces px-16 py-5">
      <div>
        <div className="spaces h-133 px-10 py-4 bg-white border-bottom border-bottom-2 d-flex">
          <Row className='mx-0'>
            <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Loại phiếu:" className="spaces min-w-110" />
              <span className="fw-light text-truncate">
                {donMauInfo?.type || (donMauInfo?.id && 'Phiếu chỉ định') || '...'}
              </span>
            </Col>
            <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Ngày y lệnh:" className="spaces min-w-110" />
              <TimeEditor
                name="doctorOrderDay"
                values={donMauInfo}
                isEditingTime={doctorOrderDayManager.isEditingTime}
                editedTime={doctorOrderDayManager.editedTime}
                showValidationConfirm={doctorOrderDayManager.showValidationConfirm}
                validationMessage={doctorOrderDayManager.validationMessage}
                onEdit={doctorOrderDayManager.handleEditTime}
                onCancel={doctorOrderDayManager.handleCancelEdit}
                onSave={doctorOrderDayManager.handleSaveTime}
                onConfirmValidation={doctorOrderDayManager.handleConfirmValidation}
                onCancelValidation={doctorOrderDayManager.handleCancelValidation}
                onTimeChange={doctorOrderDayManager.setEditedTime}
                allowEdit={allowEdit}
              />
            </Col>
            <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Ngày chỉ định:" className="spaces min-w-110" />
              <TimeEditor
                name="designatedDate"
                values={donMauInfo}
                isEditingTime={designatedDateManager.isEditingTime}
                editedTime={designatedDateManager.editedTime}
                showValidationConfirm={designatedDateManager.showValidationConfirm}
                validationMessage={designatedDateManager.validationMessage}
                onEdit={designatedDateManager.handleEditTime}
                onCancel={designatedDateManager.handleCancelEdit}
                onSave={designatedDateManager.handleSaveTime}
                onConfirmValidation={designatedDateManager.handleConfirmValidation}
                onCancelValidation={designatedDateManager.handleCancelValidation}
                onTimeChange={designatedDateManager.setEditedTime}
                allowEdit={allowEdit}
              />
            </Col>
            <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Mã phiếu:" className="spaces min-w-110" />
              <span className="fw-light text-truncate">{donMauInfo?.code || '...'}</span>
            </Col>
            <Col xs={8} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Nơi chỉ định:" className="spaces min-w-110" />
              <SelectEditor
                name="designatedPlace"
                values={{
                  designatedPlace: donMauInfo?.designatedPlace
                }}
                options={danhSachDanhMuc?.listPhongKham || []}
                inline={true}
                menuPlacement="top"
                isEditingSelect={designatedPlaceSelectManager.isEditingSelect}
                editedValue={designatedPlaceSelectManager.editedValue}
                showValidationConfirm={designatedPlaceSelectManager.showValidationConfirm}
                showConfirmWithReason={designatedPlaceSelectManager.showConfirmWithReason}
                validationMessage={designatedPlaceSelectManager.validationMessage}
                onEdit={designatedPlaceSelectManager.handleEditSelect}
                onCancel={designatedPlaceSelectManager.handleCancelEdit}
                onSave={designatedPlaceSelectManager.handleSaveSelect}
                onConfirmValidation={designatedPlaceSelectManager.handleConfirmValidation}
                onCancelValidation={designatedPlaceSelectManager.handleCancelValidation}
                onConfirmWithReason={designatedPlaceSelectManager.handleConfirmWithReason}
                onCancelWithReason={designatedPlaceSelectManager.handleCancelWithReason}
                onValueChange={designatedPlaceSelectManager.setEditedValue}
                allowEdit={allowEdit}
              />
            </Col>
            <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Người chỉ định:" className="spaces min-w-110" />
              <SelectEditor
                name="designatedPerson"
                values={{
                  designatedPerson: donMauInfo?.designatedPerson
                }}
                options={[]}
                searchFunction={seachUserMetadata}
                searchObject={{ position: 1 }}
                urlData="data.content"
                getOptionLabel={(opt) => opt?.fullName || ""}
                inline={true}
                menuPlacement="top"
                isEditingSelect={indicationPersonSelectManager.isEditingSelect}
                editedValue={indicationPersonSelectManager.editedValue}
                showValidationConfirm={indicationPersonSelectManager.showValidationConfirm}
                showConfirmWithReason={indicationPersonSelectManager.showConfirmWithReason}
                validationMessage={indicationPersonSelectManager.validationMessage}
                onEdit={indicationPersonSelectManager.handleEditSelect}
                onCancel={indicationPersonSelectManager.handleCancelEdit}
                onSave={indicationPersonSelectManager.handleSaveSelect}
                onConfirmValidation={indicationPersonSelectManager.handleConfirmValidation}
                onCancelValidation={indicationPersonSelectManager.handleCancelValidation}
                onConfirmWithReason={indicationPersonSelectManager.handleConfirmWithReason}
                onCancelWithReason={indicationPersonSelectManager.handleCancelWithReason}
                onValueChange={indicationPersonSelectManager.setEditedValue}
                allowEdit={allowEdit}
              />
            </Col>
            <Col xs={8} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Trạng thái:" className="spaces min-w-110" />
              <span className="fw-light text-truncate">
                {donMauInfo?.statusName || '...'}
              </span>
            </Col>
            <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Kho:" className="spaces min-w-110" />
              <span className="fw-light text-truncate">
                {donMauInfo?.warehouseName || '...'}
              </span>
            </Col>
            <Col xs={8} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Chẩn đoán:" className="spaces min-w-110" />
              <span className="fw-light text-truncate">
                {donMauInfo?.provisionalDiagnosisName || '...'}
              </span>
            </Col>
          </Row>
        </div>
        <div className="px-10 py-5 spaces mb-4">
          <InputSearch
            value={""}
            placeholder="Tìm kiếm"
            handleChange={() => { }}
            // handleKeyDown={onKeydown}
            // handleSearch={onBtnSearchClick}
            className="spaces h-25 radius-3"
          />
        </div>
        <div className="px-7 spaces pb-4">
          <DanhSachPhieu
            dsPhieu={dsPhieu || []}
            handleSelectRowData={(data) => setSelectedPhieu(data)}
            title="price"
            isGetFirstData
          />
        </div>
        <TableCustom<any>
          className="overflow-auto spaces h-calc-vh-425"
          data={donMauInfo?.lstMedicalItemOrderRes?.map((row: any) => ({
            ...row,
            maMau: row.medicalItemCode,
            tenMau: row.name,
            donVi: row.unit,
            soLuong: row.totalQuantity,
            donGia: row.unitPrice,
            thanhTien: row.intoMoney,
          })) || []}
          columns={mauColumn}
        />

        <ThaoTacDonThuoc donMauInfo={donMauInfo} getDanhSachDonThuoc={handleGetDsPhieu} handleSelectPhieu={handleSelectPhieu} allowOrder={allowOrder} />
      </div>
    </Row>
  )
}

export default Mau

const ThaoTacDonThuoc = ({ donMauInfo, getDanhSachDonThuoc, handleSelectPhieu, allowOrder = true }: {
  getDanhSachDonThuoc: () => void;
  donMauInfo: any;
  handleSelectPhieu: (id: number | string) => void;
  allowOrder?: boolean
}) => {
  const { benhNhanHanhChinh, statusChangedEventFunc } = usePhanHeNoiTruContext();

  const [guiDonThuoc, setGuiDonThuoc] = useState<boolean>();
  const [openDonThuocDialog, setOpenDonThuocDialog] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [keyOpenPhieuIn, setKeyOpenPhieuIn] = useState<string>('');
  const [isUpdateWorkflow, setIsUpdateWorkflow] = useState(false);

  const isXuatKho = [
    WORKFLOW_MEDICAL_ITEM_STATUS_CODE.CHO_XUAT_KHO,
    WORKFLOW_MEDICAL_ITEM_STATUS_CODE.DA_XUAT_KHO,
  ].includes(donMauInfo?.statusCode);

  const onDeleteDonThuoc = async () => {
    try {
      const response = await deleteDonThuoc(donMauInfo.id);
      if (CODE.SUCCESS === response.code) {
        toast.success(RESPONSE_MESSAGE.DELETE.SUCCESS);
        setOpenConfirmDialog(false);
        getDanhSachDonThuoc();
        statusChangedEventFunc?.();
      } else {
        let errorMessage = response?.data?.[0]?.errorMessage || RESPONSE_MESSAGE.ERROR;
        toast.warn(errorMessage);
      }
    } catch (error) {
      console.error(error);
      toast.error(RESPONSE_MESSAGE.ERROR);
    }
  };

  const handlePressKeyShortcuts = (e: any) => {
    switch (e.key) {
      case KEY.F3:
        e.preventDefault();
        setKeyOpenPhieuIn('F3');
        break;
      default:
        return;
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handlePressKeyShortcuts);
    return () => {
      window.removeEventListener('keydown', handlePressKeyShortcuts);
    };
  }, []);

  useEffect(() => {
    setGuiDonThuoc(donMauInfo?.statusCode === WORKFLOW_MEDICAL_ITEM_STATUS_CODE.GUI_DON);
  }, [donMauInfo?.statusCode]);

  const PrintButton = () => {
    return (
      <ButtonInPhieu<IInPhieuChiDinhThuocParams>
        fetchExport={printPhieuChiDinhThuoc}
        params={{
          fileType: 'pdf',
          patientId: benhNhanHanhChinh?.patientId,
          medicalItemGroupId: donMauInfo.id,
          visitId: benhNhanHanhChinh?.visitId,
          type: parseInt(ORDER_TYPE_ID.MAU),
        }}
        label="In đơn máu (F3)"
        className="btn-fill"
        keyOpenPhieuIn={keyOpenPhieuIn}
        setKeyOpenPhieuIn={setKeyOpenPhieuIn}
        keyBtn={KEY.F3}
      />
    );
  };

  const WorkFlowButton = () => {
    return (
      <WfButton
        tracker={WfConstTrackerClinical.MEDICAL_ITEMS}
        objectId={donMauInfo?.id}
        prefixFunction={(statusCode: string, callbackFn: () => any, cancel?: () => void) => {
          if (WORKFLOW_MEDICAL_ITEM_STATUS_CODE.CHUA_GUI_DON === statusCode) {
            onGuiDonThuoc(callbackFn, cancel)
            return;
          }

          onHuyGuiDonThuoc(callbackFn, cancel);
        }}
        additionalFunc={(status: any) => {
          onUpdateWorkflowStatus(status);
        }}
        forceRender={isUpdateWorkflow}
      ></WfButton>
    );
  };

  const onGuiDonThuoc = async (callbackFn: () => void, cancel?: () => void) => {
    try {
      const { data } = await updateKeThuoc({
        ...donMauInfo,
        encounterId: donMauInfo?.encounterId,
        orderTypeId: parseInt(ORDER_TYPE_ID.MAU),
        lstMedicalItemOrder: donMauInfo?.lstMedicalItemOrderRes,
        formCode: REQUEST_FROM.DIEU_TRI,
        medicalItemTypeCode: REQUEST_TYPE.MAU,
        visitObjectTypeCode: benhNhanHanhChinh?.visitObjectTypeCode
      });
      if (CODE.SUCCESS === data?.code) {
        toast.success('Gửi đơn máu thành công');
        callbackFn();
      } else {
        toast.error(getErrorMessage({ data }));
        cancel?.();
      }
    } catch (error) {
      console.error(error);
      toast.error(RESPONSE_MESSAGE.ERROR);
      cancel?.();
    }
  };

  const onHuyGuiDonThuoc = async (callbackFn: () => void, cancel?: () => void) => {
    try {
      const { code, data } = await huyGuiDonThuoc(donMauInfo?.id);
      if (CODE.SUCCESS === code) {
        toast.success('Huỷ gửi đơn máu thành công');
        callbackFn();
      } else {
        toast.error(getErrorMessage({ code, data }));
        cancel?.();
      }
    } catch (error) {
      console.error(error);
      toast.error(RESPONSE_MESSAGE.ERROR);
      cancel?.();
    }
  };

  const onUpdateWorkflowStatus = (workflowStatus: string) => {
    setGuiDonThuoc(workflowStatus === WORKFLOW_MEDICAL_ITEM_STATUS_CODE.GUI_DON);
    handleSelectPhieu(donMauInfo?.id);
  };

  if (!donMauInfo?.id) return <div className="bg-white spaces min-h-50"></div>;

  if (isXuatKho) return <div className="d-flex gap-3 bg-white p-2">{PrintButton()}</div>;

  return (
		<div className="d-flex gap-3 justify-content-start p-2 bg-white">
			{guiDonThuoc ? (
				<>
					{PrintButton()}
          {donMauInfo?.isAllowModify && allowOrder && WorkFlowButton()}
				</>
			) : (
				<>
					{donMauInfo?.isAllowModify &&
						![WORKFLOW_MEDICAL_ITEM_STATUS_CODE.DANG_TONG_HOP].includes(
							donMauInfo?.statusCode
              ) && allowOrder && (
							<>
								<Button
									className="btn-navy-outlined mr-5"
									onClick={() => setOpenDonThuocDialog(true)}
								>
									Sửa đơn máu
								</Button>
								{WorkFlowButton()}
								<Button
									className="btn-secondary mr-5"
									onClick={() => setOpenConfirmDialog(true)}
								>
									Xóa đơn máu
								</Button>
							</>
						)}
				</>
			)}

			{openDonThuocDialog && (
				<ChiDinhMau
					handleClose={() => {
						setOpenDonThuocDialog(false);
					}}
					itemEdit={donMauInfo}
					callbackFunc={() => {
						setOpenDonThuocDialog(false);
						setIsUpdateWorkflow(!isUpdateWorkflow);
						handleSelectPhieu(donMauInfo?.id);
					}}
					phieuDieuTri={{
						id: donMauInfo?.treatmentSheetId,
						prescriptionDate: donMauInfo?.treatmentSheetCreatedDate,
					}}
				/>
			)}

			{openConfirmDialog && (
				<ConfirmDialog
					className="z-index-1060"
					show={openConfirmDialog}
					title="Thông báo"
					message="Bạn có chắc chắn muốn xóa đơn máu này không ?"
					yes="Xác nhận"
					close="Đóng"
					onCloseClick={() => {
						setOpenConfirmDialog(false);
					}}
					onYesClick={onDeleteDonThuoc}
				/>
			)}
		</div>
  );
};